import React, { useEffect } from "react";
import CustomDateInput from "../../../../../../../Components/CustomInputs/CustomDateInput";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import {
   addErrorMessage,
   handleShowErrorMessage,
   removeErrorMessage,
   resetClaimFieldErrors,
} from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import useFetch from "../../../../../../../CustomHooks/useFetch";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const InjuryDateOfClaimFromField: React.FC = () => {
   const dispatch = useDispatch();

   const DateOfClaimFromValueInjury = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 0
         )?.dateOfClaimFrom
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   const token = useSelector((state: StoreType) => state.tokenState.token);
   const { personalId } = useSelector(
      (state: StoreType) => state.claimState.clientIdentification
   );

  //  const {
  //     sendRequest: sendRequestValidateDate,
  //     data: dataValidateDate,
  //     error: errorValidateDate,
  //     resetFetch: resetFetchValidateDate,
  //     fetchFired: fetchFiredValidateDate,
  //  } = useFetch();

  //  const callValidateDate = (date: string) => {
  //     sendRequestValidateDate({
  //        method: "POST",
  //        url:
  //           process.env.REACT_APP_BaseURL! +
  //           process.env.REACT_APP_ValidateDateForClaimType!,
  //        headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //        },
  //        data: {
  //           personId: personalId,
  //           injuryDateValue: date,
  //           typeOfClaimEnum: 0,
  //        },
  //     });
  //  };

  //  useEffect(() => {
  //     if (dataValidateDate === false) {
  //        dispatch(
  //           addErrorMessage({
  //              propertyId: "injury.DateOfClaimFrom",
  //              message: "Pojištění nebylo aktivní v uvedeném datu",
  //           })
  //        );
  //     } else {
  //        dispatch(removeErrorMessage("injury.DateOfClaimFrom"));
  //     }
  //  }, [fetchFiredValidateDate]);
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, "injury.DateOfClaimFrom");
   return (
      <CustomDateInput
         labelText="Kdy k úrazu došlo"
         name="DateOfClaimFrom"
         placeholderText="DD.MM.RRRR"
         value={DateOfClaimFromValueInjury || undefined}
         onChange={(val: string | null) => {
            dispatch(
               updateFirstStepDynamicFields({
                  value: val,
                  field: "dateOfClaimFrom",
                  typeOfClaimEnum: 0,
               })
            );
         }}
         validationText={handleShowErrorMessage(
            "injury.DateOfClaimFrom",
            claimFieldErrorsMessages
         )}
         dependencyValue={shouldRenderSpecField(
            "injury",
            "DateOfClaimFrom",
            visibilityMatrixes
         )}
         inputRef={ref}
      />
   );
};

export default InjuryDateOfClaimFromField;
